export * from './SearchResultsComponent';
export * from './searchResultsMainComponent';
